import { render, staticRenderFns } from "./SplitRepairs.vue?vue&type=template&id=68aa5321&scoped=true"
import script from "./SplitRepairs.vue?vue&type=script&lang=js"
export * from "./SplitRepairs.vue?vue&type=script&lang=js"
import style0 from "./SplitRepairs.vue?vue&type=style&index=0&id=68aa5321&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa5321",
  null
  
)

export default component.exports